import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

const SELECTORS = {
  element: '.js-full-width-feature',
  contentWrapper: '.js-full-width-feature-wrapper',
  contentHeader: '.js-full-width-feature-header',
  contentExcerpt: '.js-full-width-feature-excerpt'
}

class FullWidthFeature {
  constructor (element) {
    this.element = element
    this.contentWrapper = this.element.querySelector(SELECTORS.contentWrapper)
    this.contentHeader = this.element.querySelector(SELECTORS.contentHeader)
    this.contentExcerpt = this.element.querySelector(SELECTORS.contentExcerpt)
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.init()
  }

  init() {
    this.setHeightVar()
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.RESIZE, () => this.setHeightVar())
  }

  setHeightVar() {
    const wrapperPadding = this.getWrapperPadding()
    const headerHeight = this.elemHeight(this.contentHeader)
    const excerptHeight = this.elemHeight(this.contentExcerpt)
    this.element.style.setProperty('--feature-header-height', `${headerHeight + wrapperPadding}px`)
    this.element.style.setProperty('--feature-excerpt-height', `${excerptHeight + wrapperPadding}px`)
    this.element.style.setProperty('--feature-content-height', `${headerHeight + excerptHeight + wrapperPadding}px`)
  }

  getWrapperPadding() {
    if (!this.contentWrapper) {
      return 0
    }

    const styles = getComputedStyle(this.contentWrapper)
    const top = parseInt(styles.paddingTop) || 0
    const bottom = parseInt(styles.paddingTop) || 0
    return top + bottom
  }

  elemHeight(elem) {
    const styles = getComputedStyle(elem)
    const margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom)
    return elem.offsetHeight + margin
  }
}

export default {
  selector: SELECTORS.element,
  Source: FullWidthFeature
}
